import { NgModule } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

const materialComponents = [MatDialogModule]

@NgModule({
    exports: [materialComponents],
    imports: [materialComponents],
    providers: [MatDialog]
})

export class MaterialModule { }